export default __webpack_public_path__ + "static/media/Vanilla-Euphoria-1.393e5c6f.jpg";